import type { ExcursionItem } from '../../domain/types'
import { LazyImage } from '@sunwebgroup/uds-ui/lazy-image'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import styles from './ExcursionCard.module.css'

interface ExcursionCardProps {
  excursion: ExcursionItem
}

export function ExcursionCard({ excursion: { title, imageUrl, url } }: ExcursionCardProps) {
  return (
    <a href={url} className={styles.card} target="_blank" rel="noreferrer noopener">
      {imageUrl && (
        <LazyImage
          src={imageUrl}
          placeholderSrc={imageUrl}
          alt="" // Decorative image, so no alt text is needed
          loading="lazy"
          width={80}
          height={80}
          className={styles.image}
        />
      )}
      <Typography variant="body-m-bold-flat">{title}</Typography>
    </a>
  )
}
